import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=27f5280a&scoped=true&"
import script from "./ResourceCard.vue?vue&type=script&lang=js&"
export * from "./ResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCard.vue?vue&type=style&index=0&id=27f5280a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5280a",
  null
  
)

export default component.exports